import { render, staticRenderFns } from "./Historic.vue?vue&type=template&id=df3fb61a&scoped=true"
import script from "./Historic.vue?vue&type=script&lang=js"
export * from "./Historic.vue?vue&type=script&lang=js"
import style0 from "./Historic.vue?vue&type=style&index=0&id=df3fb61a&prod&lang=scss&scoped=true"
import style1 from "./Historic.vue?vue&type=style&index=1&id=df3fb61a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3fb61a",
  null
  
)

export default component.exports